// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import NomineeDetailsActionType from './basic-nominee-details.types';
import {
	nomineeDetailsAddSuccess,
	nomineeDetailsAddFailure,
	nomineeDetailsAddUserResponseChanged,
} from './basic-nominee-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { nomineeDetailsAdd } from './basic-nominee-details.service';

/** ***************** NOMINEE DETAILS ADD START *********************** */
export function* AddNomineeDetails({ payload }: any) {
	try {
		const key = 'AddMemberNomineeDetails';
		const {
			companyID,
			databaseName,
			memberID,
			nomineeRelationship,
			nomineeName,
			nomineeDOB,
			gender,
			nomineeFatherName,
			nomineeAadharNumber,
			nomineeIDProofType,
			nomineeIDProofNumber,
			nomineePhoneNumber,
			pincode,
			doorNo,
			addressStreet,
			country,
			state,
			district,
			city,
			userID,
			isAadharScanned,
			nomineeAadharVerified,
			livingInSameAddress,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			NomineeRelationship: nomineeRelationship,
			NomineeName: nomineeName,
			NomineeDOB: nomineeDOB,
			Gender: gender,
			NomineeFatherName: nomineeFatherName,
			NomineeAadharNumber: nomineeAadharNumber,
			NomineeIDProofType: nomineeIDProofType,
			NomineeIDProofNumber: nomineeIDProofNumber,
			NomineePhoneNumber: nomineePhoneNumber,
			NomineePinCode: pincode,
			NomineeDoorNo: doorNo,
			MemberNomineeAddressStreet: addressStreet,
			NomineeCountry: country,
			NomineeState: state,
			NomineeDistrict: district,
			NomineeCity: city,
			OfficerID: userID,
			IsAadharScanned: isAadharScanned,
			Secratekey: key,
			NomineeAadharVerified: nomineeAadharVerified,
			LivingInSameAddress: livingInSameAddress,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(nomineeDetailsAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(nomineeDetailsAddFailure(responseData.data));
		} else {
			yield put(nomineeDetailsAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(nomineeDetailsAddFailure(error));
	}
}

export function* AddNomineeDetailsResponseClear() {
	yield put(nomineeDetailsAddUserResponseChanged());
}

export function* onNomineeDetailsAddStart() {
	yield takeLatest(NomineeDetailsActionType.NOMINEE_DETAILS_ADD_START, AddNomineeDetails);
}

export function* onNomineeDetailsAddResponseRest() {
	yield takeLatest(
		NomineeDetailsActionType.NOMINEE_DETAILS_ADD_RESPONSE_REST_START,
		AddNomineeDetailsResponseClear,
	);
}
/** ***************** NOMINEE DETAILS ADD END *********************** */

export function* nomineeDetailsSaga() {
	yield all([call(onNomineeDetailsAddStart), call(onNomineeDetailsAddResponseRest)]);
}
